import $ from 'jquery';
import { setTokens, clearTokens, getRefreshToken } from '../utils/authStorage';
import UserSessionManager from '../utils/UserSessionManager';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const AuthService = {
  login(loginData) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${API_BASE}/Auth/user-login`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(loginData),
      success: function(resp) {
        if (resp?.success && resp?.data) {
          setTokens({
            accessToken: resp.data.accessToken,
            refreshToken: resp.data.refreshToken,
          });
          resolve(resp.data);
        } else {
          const msg = resp?.message || resp?.responseJSON?.message || 'Login failed';
          reject({ message: msg, data: resp });
        }
      },
      error: function(response) {
        const res = response?.responseJSON ?? {};
        reject({
          message: res.message || response.statusText || 'Network error',
          status: response.status,
          errors: res.errors ?? null,
        });
      },
    });
  });
},

  callRefreshToken() {
  const storedRefresh = getRefreshToken();
  if (!storedRefresh) return Promise.reject(new Error('No refresh token available'));

  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${API_BASE}/Auth/refresh-token`, 
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ refreshToken: storedRefresh }),
      success(resp) {
        const payload = resp?.data ?? resp;
        const newAccess = payload?.accessToken || payload?.token || payload?.access_token;
        const newRefresh = payload?.refreshToken || payload?.refresh_token || storedRefresh;

        if (!newAccess) {
          reject(new Error('Refresh failed: no access token returned'));
          return;
        }
        setTokens({ accessToken: newAccess, refreshToken: newRefresh });
        resolve({ accessToken: newAccess, refreshToken: newRefresh });
      },
      error(jqXHR) {
        const res = jqXHR?.responseJSON ?? {};
        reject({ message: res.message || 'Refresh failed', status: jqXHR.status, detail: res });
      },
    });
  });
},

  logout() {
  clearTokens();
  UserSessionManager.clearSession();
  localStorage.removeItem('featureFlags');
  window.location.href = '/signin';
  }
};

export default AuthService;
